import { render, staticRenderFns } from "./BaseDrainers.vue?vue&type=template&id=1b02804c&scoped=true&"
import script from "./BaseDrainers.vue?vue&type=script&lang=js&"
export * from "./BaseDrainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02804c",
  null
  
)

export default component.exports